import { Box, Flex, Heading, Input, Select, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import roboto from "@fontsource/roboto";
import style from "./index.module.css";
import { getLocation } from "services/api";

const Third = ({ formData, setformData, setPage, submitHandler }) => {
  const [locationList, setlocationList] = useState({
    country: "",
    state: "",
    city: "",
  });
  const [addressSetter, setaddressSetter] = useState({
    line1: "",
    line2: "",
    country: "",
    state: "",
    city: "",
    pincode: "",
  });

  const handleChange = (e) => {
    setaddressSetter((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
  };

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        if (!addressSetter.country) {
          const { data } = await getLocation("country=true");
          setlocationList((state) => ({
            ...state,
            country: data.data,
          }));
        } else if (addressSetter.country && !addressSetter.state) {
          const { data } = await getLocation(
            `country=${addressSetter.country}&state=true`
          );
          setlocationList((state) => ({
            ...state,
            state: data.data,
          }));
        }
        if (addressSetter.state && !addressSetter.city) {
          const { data } = await getLocation(
            `state=${addressSetter.state}&city=true`
          );
          setlocationList((state) => ({
            ...state,
            city: data.data,
          }));
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchLocation();
  }, [addressSetter]);

  // console.log(addressSetter);
  useEffect(() => {
    if (
      addressSetter.line1 &&
      addressSetter.country &&
      addressSetter.state &&
      addressSetter.city &&
      addressSetter.pincode
    ) {
      const fullAddress = () => {
        return `${addressSetter.line1}_${addressSetter?.line2 || ""}_${
          addressSetter.city
        }_${addressSetter.state}_${addressSetter.country}_${
          addressSetter.pincode
        }`;
      };
      setformData((state) => ({
        ...state,
        companyAddress: fullAddress(),
        // address1:addressSetter.line1,
        // country:addressSetter.country,
      }));
    }
  }, [addressSetter]);

  return (
    <div>
      <Box>
        <Flex
          w="100vw"
          align="center"
          justify="center"
          flexDirection="column"
          py={10}
        >
          {/* Heading */}
          <Box>
            <Heading
              style={{ fontFamily: "Epilogue" }}
              fontSize={40}
              fontWeight={700}
            >
              Setup Company
            </Heading>
            <Text fontFamily={"Roboto"} fontSize={16} fontWeight={400}>
              Add company address
            </Text>
          </Box>
          <Flex flexDir={"column"} w={[330, 330, 347, 347]}>
            {/* Address Line */}
            <Box
              border="1px solid #DCDCDC"
              py={2}
              px={2}
              borderRadius={12}
              mt={10}
            >
              <Input
                placeholder="Address Line 1"
                variant="unstyled"
                name="line1"
                onChange={handleChange}
                fontSize={16}
                fontFamily={roboto}
                // value={formData.gstNumber}
                // onChange={changeHandler}
                autoComplete="off"
                px={5}
              />
            </Box>

            <Box
              border="1px solid #DCDCDC"
              px={2}
              py={2}
              borderRadius={12}
              mt={4}
            >
              <Input
                placeholder="Address Line 2"
                variant="unstyled"
                name="line2"
                fontSize={16}
                fontFamily={roboto}
                onChange={handleChange}
                // value={formData.numberOfEmployees}
                // onChange={changeHandler}
                autoComplete="off"
                px={5}
              />
            </Box>

            {/* country and state */}
            <Flex justify={"space-between"} mt={4} gap={2}>
              {/* <Input
              borderRadius={12}
              fontSize={16}
              placeholder="Country"
              onChange={handleChange}
              name="country"
            /> */}
              <Select borderRadius={12} onChange={handleChange} name="country">
                <option value="country">Select Country</option>
                {locationList?.country &&
                  locationList?.country.map((item) => (
                    <option key={item._id} value={item.Name}>
                      {item.Name}
                    </option>
                  ))}
              </Select>
              <Select borderRadius={12} onChange={handleChange} name="state">
                <option color="#B3B3B3" value="country">
                  Select State
                </option>
                {locationList.state &&
                  locationList.state.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </Select>
            </Flex>

            {/* Pincode and City */}
            <Flex justify={"space-between"} mt={4} gap={2}>
              <Select borderRadius={12} onChange={handleChange} name="city">
                <option value="city">Select City</option>
                {locationList.city &&
                  locationList.city.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
              </Select>
              <Input
                w={"90%"}
                borderRadius={12}
                fontSize={16}
                type={"number"}
                placeholder="Pincode"
                onChange={handleChange}
                name="pincode"
              />
            </Flex>

            <div className={style.btnGroup}>
              <button className={style.backBtn} onClick={() => setPage(1)}>
                Back
              </button>
              {!addressSetter.line1 ||
              !addressSetter.country ||
              !addressSetter.state ||
              !addressSetter.city ||
              !addressSetter.pincode ? (
                <button
                  disabled
                  style={{ cursor: "not-allowed" }}
                  className={style.nextBtn}
                >
                  Submit
                </button>
              ) : (
                <button className={style.nextBtn} onClick={submitHandler}>
                  Submit
                </button>
              )}
            </div>
            <Flex
              display={"none"}
              bg={"#6C56FB"}
              align="center"
              justify="center"
              // py={[1, 1, 2, 2, 2]}
              gap={2}
              borderRadius={12}
              mt={4}
              _hover={{ bg: "#8E48FF" }}
              cursor={!formData.companyAddress ? "not-allowed" : "pointer"}
              onClick={submitHandler}
            >
              {/* Next Button */}
              <button
                style={{
                  cursor: !formData.companyAddress ? "not-allowed" : "pointer",
                  color: "#ffffff",
                  fontSize: "18px",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  letterSpacing: "0.04em",
                  padding: "0.5rem 3rem",
                }}
              >
                Submit
              </button>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </div>
  );
};

export default Third;
